import React from "react";
import "./SkipLinks.scss";
import useTranslate from "../../hooks/useTranslate";

export const SkipLinks = () => {
    const t = useTranslate();

    return (
        <nav aria-label="Skip links">
            <ul>
                <li>
                    <a href="#main-content" className="skip-link">
                        {t("book.skip_to_main")}
                    </a>
                </li>
                <li>
                    <a href="#main-navigation" className="skip-link">
                        {t("book.skip_to_navigation")}
                    </a>
                </li>
                <li>
                    <a href="#footer" className="skip-link">
                        {t("book.skip_to_footer")}
                    </a>
                </li>
            </ul>
        </nav>
    );
};
